import { Form } from 'antd';
import React from 'react';
import { PrivateKistForm } from '~/components/flight/sections/sectionKist.privateKist.form.jsx';

export const PriveKistForm = ({ kist, onSave, onCancel, loading }) => {
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    try {
      const formData = {
        ...values,
        id: kist.id,
        isNew: kist.isNew || false,
        category: values.kist_category,
        start_methode: values.start_methode,
      };
      await onSave(formData);
    } catch (error) {
      console.error('Form submission error:', error);
    }
  };

  return (
    <div data-kist-id={kist?.id}>
      <PrivateKistForm
        form={form}
        layout="horizontal"
        initialValues={{
          registratie: kist?.registration || kist?.registratie || '',
          callsign: kist?.callsign || '',
          type: kist?.type || '',
          flarm: kist?.flarm || '',
          default_pilot_id: kist?.default_pilot_id || null,
          category: kist?.category || 'prive',
          start_methode: kist?.start_methode || null
        }}
        onFinish={handleSubmit}
        disabled={loading}
        setDefaultPilot={true}
      />
    </div>
  );
};